import { SortDirectionEnum } from 'app/shared/enums/sort-direction.enum';

export class UsersSettingConstant {
  public static headerData: any[] = [
    {
      value: 'name',
      class: 'name',
      name: 'Name',
      isSelectable: true,
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'role',
      class: 'role_header',
      name: 'Role',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'permission',
      class: 'permission_header',
      name: 'Permission',
      isSortApplicable: false,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'access',
      class: 'access_header',
      name: 'Access',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    // {
    //   value: 'framework',
    //   class: 'framework',
    //   name: 'Assigned',
    //   isSortApplicable: false,
    //   isSortApplied: false,
    //   sortDirection: SortDirectionEnum.NONE,
    // },
    {
      value: 'artifacts',
      class: 'artifacts',
      name: 'Artifacts',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'invitationDate',
      class: 'invitation-date',
      name: 'Invitation Date',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'lastLogin',
      class: 'last-login',
      name: 'Last Login',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'email',
      class: 'email',
      name: 'Email',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'apiAccess',
      class: 'api',
      name: 'API',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
    {
      value: 'phone',
      class: 'phone',
      name: 'Phone',
      isSortApplicable: false,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.NONE,
    },
  ];
}

export enum DynamicLabelManagerSections {
  GENERAL_TAGS = 'General Tags',
  RISK_REGISTER = 'Risk Register',
  POLICY_MANAGEMENT = 'Policy Management',
  RISK_TAGS = 'Risk Tags',
  RISK_CATEGORIES = 'Risk Categories',
  POLICY_TAGS = 'Policy Tags',
  POLICY_CATEGORIES = 'Policy Categories',
  GENERAL_CATEGORIES = 'General Categories',
  POLICY_SUB_CATEGORIES = 'Policy SubCategories',
  POLICY_CUSTOM_CATEGORIES = 'Policy Custom Categories',
  POLICY_CUSTOM_SUB_CATEGORIES = 'Policy Custom SubCategories',
  REMEDIATION = 'Remediation',
  REMEDIATION_TAGS = 'Remediation Tags',
  REMEDIATION_CATEGORIES = 'Remediation Categories',
  INSTRUCTIONS = 'Instructions',
}

export const CATEGORY_GROUPS = [
  {
    name: 'Security',
    color: '#29a9eb',
    items: [
      'Information Security Policy',
      'Access Policy',
      'Asset Management',
      'Device Usage Policy',
      'Physical Security',
    ],
  },
  {
    name: 'Privacy',
    color: '#a259e6',
    items: ['Privacy Policy', 'DPO Statement', 'Data Category'],
  },
  {
    name: 'Regulation',
    color: '#e659a2',
    items: ['Environmental Policy', 'Paper Policy'],
  },
  {
    name: 'Organizational Policy',
    color: '#3ec46d',
    items: [
      'Business Continuity',
      'Disaster Recovery',
      'Insurance',
      'Hiring Employees',
      'Employee Termination',
      'Incident Response',
    ],
  },
];
